import { toast } from 'react-toastify'

let appRoot

const toastSettings = {
  configureToast: () => {
    toast.configure({
      autoClose: 5000,
      closeOnClick: true,
      draggable: true,
      position: 'bottom-left',
      hideProgressBar: true,
    })
  },
  setAppElement: element => {
    if (element) {
      appRoot = element
    }
  },
  getAppElement: () => appRoot,
}

export default toastSettings
